<div class="container relative md:mt-24 mt-16">
  <div class="grid grid-cols-1 pb-6 text-center">
    <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">What Our Guests Say</h3>
    <p class="text-slate-400 max-w-xl mx-auto">
      Real stories from real people. Discover why travelers choose HarmoNest for comfort, convenience, and memorable stays.
    </p>
  </div>

  <div class="grid grid-cols-1 mt-6">
    <div class="tiny-three-item">
      <div *ngFor="let item of clientData" class="tiny-slide text-center">
        <div class="cursor-e-resize">
          <div class="content relative rounded shadow dark:shadow-gray-700 m-2 p-6 bg-white dark:bg-slate-900 before:content-[''] before:absolute before:start-1/2 before:-bottom-[4px] before:box-border before:border-8 before:rotate-[45deg] before:border-t-transparent before:border-e-white dark:before:border-e-slate-900 before:border-b-white dark:before:border-b-slate-900 before:border-s-transparent before:shadow-testi dark:before:shadow-gray-700 before:origin-top-left">
            <i class="mdi mdi-format-quote-open mdi-48px text-red-500"></i>
            <p class="text-slate-400">{{item.desc}}</p>
            <ul class="list-none mb-0 text-amber-400 mt-3">
              <li class="inline"><i class="mdi mdi-star"></i></li>
              <li class="inline"><i class="mdi mdi-star"></i></li>
              <li class="inline"><i class="mdi mdi-star"></i></li>
              <li class="inline"><i class="mdi mdi-star"></i></li>
              <li class="inline"><i class="mdi mdi-star"></i></li>
            </ul>
          </div>

          <div class="text-center mt-5">
            <img [src]="item.image" class="size-14 rounded-full shadow-md dark:shadow-gray-700 mx-auto" alt="{{item.name}}">
            <h6 class="mt-2 font-semibold">{{item.name}}</h6>
            <span class="text-slate-400 text-sm">{{item.position}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
